import React from 'react';
import { Settings } from './Settings';

/**
 * Backward-compatible profile route mapped to Settings page.
 */
export const Profile = () => <Settings />;

